import { render, staticRenderFns } from "./XdocProjectPlanForJson.vue?vue&type=template&id=8e523572&scoped=true"
import script from "./XdocProjectPlanForJson.vue?vue&type=script&lang=ts"
export * from "./XdocProjectPlanForJson.vue?vue&type=script&lang=ts"
import style0 from "./XdocProjectPlanForJson.vue?vue&type=style&index=0&id=8e523572&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e523572",
  null
  
)

export default component.exports